import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck, Users } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="relative pt-12 pb-20 md:pt-20 md:pb-32 overflow-hidden" data-id="element-68">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-69">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] rounded-full bg-brand-100/50 blur-3xl opacity-60" data-id="element-70" />
        <div className="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] rounded-full bg-accent-50/50 blur-3xl opacity-60" data-id="element-71" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-72">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-73">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-74">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-100 text-brand-800 font-medium text-sm mb-6" data-id="element-75">
              <ShieldCheck className="w-4 h-4" data-id="element-76" />
              <span data-id="element-77">Solución probada por +2,000 mujeres en USA</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold leading-tight text-slate-900 mb-6" data-id="element-78">
              Elimina el Dolor de la Fascitis Plantar y Vuelve a Caminar sin
              Agonía{' '}
              <span className="text-brand-600 relative whitespace-nowrap" data-id="element-79">
                desde el Primer Paso
                <svg className="absolute w-full h-3 -bottom-1 left-0 text-accent-500 opacity-70" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-80">
                  <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="3" fill="transparent" data-id="element-81" />
                </svg>
              </span>{' '}
              del Día
            </h1>

            <p className="text-lg md:text-xl text-slate-600 mb-8 leading-relaxed" data-id="element-82">
              El Protocolo de Alivio de 2 Minutos diseñado para mujeres que
              trabajan de pie en USA y necesitan una solución real, rápida y
              económica.
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-8" data-id="element-83">
              <CTAButton data-id="element-84" />
            </div>

            <div className="flex items-center gap-4 text-sm text-slate-600" data-id="element-85">
              <div className="flex -space-x-2" data-id="element-86">
                {[1, 2, 3, 4].map(i => <img key={i} src={`https://i.pravatar.cc/100?img=${i + 10}`} alt="User" className="w-10 h-10 rounded-full border-2 border-white" data-id="element-87" />)}
              </div>
              <div data-id="element-88">
                <div className="flex text-yellow-400 mb-1" data-id="element-89">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-90" />)}
                </div>
                <p data-id="element-91">
                  Basado en{' '}
                  <span className="font-semibold text-slate-900" data-id="element-92">4.9/5</span>{' '}
                  reseñas
                </p>
              </div>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative lg:ml-auto" data-id="element-93">
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl shadow-brand-900/10 bg-white p-2" data-id="element-94">
              <img src="https://cdn.magicpatterns.com/uploads/sS45PSteGNGFpk5KvPdH3J/PATAS_77.png" alt="Adiós a la Fascia Plantar eBook en múltiples dispositivos" className="w-full h-auto rounded-xl" data-id="element-95" />
            </div>

            {/* Floating badge */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.8,
            duration: 0.5
          }} className="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-xl border border-slate-100 flex items-center gap-3 z-20" data-id="element-96">
              <div className="bg-green-100 p-2 rounded-full text-green-600" data-id="element-97">
                <Users className="w-6 h-6" data-id="element-98" />
              </div>
              <div data-id="element-99">
                <p className="text-xs text-slate-500 font-medium uppercase tracking-wider" data-id="element-100">
                  Comunidad
                </p>
                <p className="font-bold text-slate-900" data-id="element-101">+2,000 Descargas</p>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}